export const UPLOAD_STATES = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  DONE: 'DONE',
  FAILED: 'FAILED'
}

export const UPLOAD_TYPE = 'Upload'
